(() => {
  const closeSubmenu = (item) => {
    const toggle = item.querySelector('[data-ce-submenu-toggle]');
    const submenu = item.querySelector('[data-ce-submenu]');
    item.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (submenu && submenu.classList.contains('ce-mobile-submenu')) submenu.hidden = true;
  };

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('.ce-form-errors, .ce-form-success')?.focus();

    const cartAction = document.querySelector('.ce-cart-action');
    const animateCart = () => {
      if (!cartAction || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      cartAction.classList.remove('ce-cart-added');
      window.requestAnimationFrame(() => {
        cartAction.classList.add('ce-cart-added');
        window.setTimeout(() => cartAction.classList.remove('ce-cart-added'), 300);
      });
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, animateCart);
    }
    document.addEventListener('cart:updated', animateCart);

    const header = document.querySelector('[data-ce-header]');
    if (!header) return;

    const mobileToggle = header.querySelector('[data-ce-mobile-toggle]');
    const mobileMenu = header.querySelector('[data-ce-mobile-menu]');
    const mobileClose = header.querySelector('[data-ce-mobile-close]');
    let menuCloseTimer;

    const isMobileMenuOpen = () => mobileToggle?.getAttribute('aria-expanded') === 'true';

    const getFocusableMenuItems = () => Array.from(mobileMenu?.querySelectorAll(focusableSelector) || [])
      .filter((element) => !element.closest('[hidden]') && element.getClientRects().length > 0);

    const openMobileMenu = () => {
      if (!mobileToggle || !mobileMenu || isMobileMenuOpen()) return;
      window.clearTimeout(menuCloseTimer);
      mobileMenu.hidden = false;
      mobileMenu.setAttribute('aria-hidden', 'false');
      mobileToggle.setAttribute('aria-expanded', 'true');
      mobileToggle.setAttribute('aria-label', 'Close menu');
      document.body.classList.add('ce-menu-open');

      window.requestAnimationFrame(() => {
        mobileMenu.classList.add('is-open');
        window.requestAnimationFrame(() => {
          mobileMenu.querySelector('[data-ce-mobile-first]')?.focus();
        });
      });
    };

    const closeMobileMenu = ({ restoreFocus = true, immediate = false } = {}) => {
      if (!mobileToggle || !mobileMenu || (!isMobileMenuOpen() && mobileMenu.hidden)) return;
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      mobileToggle.setAttribute('aria-expanded', 'false');
      mobileToggle.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('ce-menu-open');
      mobileMenu.querySelectorAll('[data-ce-nav-item].is-open').forEach(closeSubmenu);

      if (restoreFocus) mobileToggle.focus();
      window.clearTimeout(menuCloseTimer);
      if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        mobileMenu.hidden = true;
      } else {
        menuCloseTimer = window.setTimeout(() => {
          mobileMenu.hidden = true;
        }, 240);
      }
    };

    mobileToggle?.addEventListener('click', () => {
      if (isMobileMenuOpen()) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    mobileClose?.addEventListener('click', () => closeMobileMenu());

    header.querySelectorAll('[data-ce-submenu-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const item = toggle.closest('[data-ce-nav-item]');
        const submenu = item?.querySelector('[data-ce-submenu]');
        const open = toggle.getAttribute('aria-expanded') === 'true';

        item?.parentElement?.querySelectorAll('[data-ce-nav-item].is-open').forEach((other) => {
          if (other !== item) closeSubmenu(other);
        });

        item?.classList.toggle('is-open', !open);
        toggle.setAttribute('aria-expanded', String(!open));
        if (submenu && submenu.classList.contains('ce-mobile-submenu')) submenu.hidden = open;
      });
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) {
        header.querySelectorAll('[data-ce-nav-item].is-open').forEach(closeSubmenu);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        header.querySelectorAll('[data-ce-nav-item].is-open').forEach(closeSubmenu);
        if (isMobileMenuOpen()) closeMobileMenu();
        return;
      }

      if (event.key !== 'Tab' || !isMobileMenuOpen()) return;
      const focusableItems = getFocusableMenuItems();
      const firstItem = focusableItems[0];
      const lastItem = focusableItems[focusableItems.length - 1];
      if (!firstItem || !lastItem) return;

      if (event.shiftKey && document.activeElement === firstItem) {
        event.preventDefault();
        lastItem.focus();
      } else if (!event.shiftKey && document.activeElement === lastItem) {
        event.preventDefault();
        firstItem.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth < 990 || mobileMenu?.hidden) return;
      closeMobileMenu({ restoreFocus: false, immediate: true });
    });
  });
})();
